import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [{
	path: routeList.APPROVALS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
{
	path: routeList.APPROVALS_PENDING_SIGNATURE_PATH,
	name: routeList.APPROVALS_PENDING_SIGNATURE_NAME,
	props: true,
	component: () => import('@/views/approvals/PendingSignature')
},
/* ***********************************************
*                    OPERATORS                   *
*********************************************** */
{
	path: routeList.APPROVALS_OPERATORS_PATH,
	name: routeList.APPROVALS_OPERATORS_NAME,
	component: () => import('@/views/approvals/operators/Consult')
}, {
	path: routeList.APPROVALS_OPERATORS_CREATE_PATH,
	name: routeList.APPROVALS_OPERATORS_CREATE_NAME,
	component: () => import('@/views/approvals/operators/Create')
}, {
	path: routeList.APPROVALS_OPERATORS_EDIT_PATH,
	name: routeList.APPROVALS_OPERATORS_EDIT_NAME,
	props: true,
	component: () => import('@/views/approvals/operators/Edit'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
}, {
	path: routeList.APPROVALS_OPERATORS_DELETE_PATH,
	name: routeList.APPROVALS_OPERATORS_DELETE_NAME,
	props: true,
	component: () => import('@/views/approvals/operators/Delete'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
}, {
	path: routeList.APPROVALS_OPERATORS_BLOCK_PATH,
	name: routeList.APPROVALS_OPERATORS_BLOCK_NAME,
	props: true,
	component: () => import('@/views/approvals/operators/Block'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
}, {
	path: routeList.APPROVALS_OPERATORS_UNBLOCK_PATH,
	name: routeList.APPROVALS_OPERATORS_UNBLOCK_NAME,
	props: true,
	component: () => import('@/views/approvals/operators/Unblock'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.APPROVALS_OPERATORS_NAME)
	}
},
/* ******************************************** */
{
	path: routeList.APPROVALS_SIGNED_PATH,
	name: routeList.APPROVALS_SIGNED_NAME,
	component: () => import('@/views/approvals/Signed')
}]
